import script from "./NoticeMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./NoticeMenu.vue?vue&type=script&setup=true&lang=ts"

import "./NoticeMenu.vue?vue&type=style&index=0&id=4e8c31e0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e8c31e0"]])

export default __exports__